/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEzNV8zOCkiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC41IDAuNVYxNS41SDE1LjVWMC41SDAuNVpNMS41IDEuNUgxNC41VjYuNUgxLjVWMS41Wk0xLjUgMTQuNVY3LjVIMTQuNVYxNC41SDEuNVpNOCAzLjVIM1Y0LjVIOFYzLjVaTTExIDMuNUgxM1Y0LjVIMTFWMy41WiIgZmlsbD0iaW5oZXJpdCIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImNsaXAwXzEzNV8zOCI+PHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPjwvY2xpcFBhdGg+PC9kZWZzPg==";